export default __webpack_public_path__ + "static/media/srt-file.a0e408c1.svg";